import MuiTable from "@mui/material/Table";
import { tableCellClasses } from "@mui/material/TableCell";
import { tableRowClasses } from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
const PREFIX = "Table";
export const classes = {
    noBorder: `${PREFIX}-noBorder`,
    evenColor: `${PREFIX}-evenColor`,
    oddColor: `${PREFIX}-oddColor`,
    rowNoColor: `${PREFIX}-rowNoColor`,
    separator: `${PREFIX}-separator`,
    item: `${PREFIX}-item`,
    description: `${PREFIX}-description`,
    itemevenColor: `${PREFIX}-itemevenColor`,
    itemoddColor: `${PREFIX}-itemoddColor`
};
export const Root = styled("div")(({ theme }) => ({
    [`.${classes.noBorder}`]: {
        border: 0,
        "& tbody": {
            "& tr": {
                "& td": {
                    borderBottom: "0px"
                }
            }
        }
    },
    [`.${classes.evenColor}`]: {
        borderTop: `1px solid ${theme.colours.storm}`,
        "& tbody": {
            "& tr": {
                "&:nth-of-type(even)": {
                    backgroundColor: theme.colours.pearl
                }
            }
        }
    },
    [`.${classes.oddColor}`]: {
        borderTop: "none",
        "& tbody": {
            "& tr": {
                "&:nth-of-type(odd)": {
                    backgroundColor: theme.colours.pearl
                }
            }
        }
    },
    [`.${classes.rowNoColor}`]: {
        "& tbody": {
            "& tr": {
                borderTop: `1px solid ${theme.colours.storm}`,
                "&:first-of-type": {
                    borderTop: "none"
                }
            }
        }
    },
    [`.${classes.separator}`]: {
        borderBottom: `1px solid ${theme.colours.storm}`
    },
    [`.${classes.item}`]: {
        wordBreak: "break-all",
        margin: 0,
        padding: "16px",
        listStyle: "none"
    },
    [`.${classes.description}`]: {
        margin: "0 0 16px 0",
        "&:last-child": {
            margin: 0
        }
    },
    [`.${classes.itemevenColor}`]: {
        [`.${classes.item}`]: {
            "&:nth-of-type(even)": {
                backgroundColor: theme.colours.pearl
            }
        }
    },
    [`.${classes.itemoddColor}`]: {
        [`.${classes.item}`]: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.colours.pearl
            }
        }
    },
    [`& .${tableRowClasses.head}`]: {
        border: `1px solid ${theme.colours.storm}`
    },
    [`& .${tableCellClasses.head}`]: {
        color: "inherit",
        padding: "16px",
        fontWeight: "bold"
    },
    [`& .${tableCellClasses.body}`]: {
        padding: "1rem 16px 0.67rem",
        verticalAlign: "top",
        border: 0
    },
    [`& .${tableCellClasses.head}, .${tableCellClasses.body}`]: {
        fontSize: "16px",
        [theme.breakpoints.up("sm")]: {
            fontSize: "18px"
        }
    }
}));
export const StyledTable = styled(MuiTable)(({ theme }) => ({
    border: `1px solid ${theme.colours.storm}`
}));
export const StyledSmallTable = styled("div")(({ theme }) => ({
    border: `1px solid ${theme.colours.storm}`,
    fontSize: "16px",
    [theme.breakpoints.up("sm")]: {
        fontSize: "18px"
    },
    [`&.${classes.noBorder}`]: {
        border: 0
    }
}));
export const Title = styled("dt")({ fontWeight: "bold" });
//# sourceMappingURL=data:application/json;base64,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